module.exports = __webpack_public_path__ + "img/avatar-14.93af0727.png";